import { render, staticRenderFns } from "./content2.vue?vue&type=template&id=28628e40&scoped=true"
import script from "./content2.vue?vue&type=script&lang=js"
export * from "./content2.vue?vue&type=script&lang=js"
import style0 from "./content2.vue?vue&type=style&index=0&id=28628e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28628e40",
  null
  
)

export default component.exports